import styled from "styled-components";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

import routes from "../../routes";
import { useSelector } from "react-redux";
import { selectUser } from "../auth/authSlice";

const S = {
    Footer: styled.footer`
      @media print {
        display: none;
      }
      
      background-color: #2d3e50;
      color: #b6b6b6;
      padding: 32px 0px 12px 0px;
    `,
    Link: styled(Link)`
      color: #e3e3e3;
      font-weight: 600;

      :hover {
        color: #ffffff;
      }
    `,
}

const Footer = () => {
  const user = useSelector(selectUser)

  return (
    <S.Footer>
        <Container>
            { routes
                .filter(route => route.inFooter)
                .filter(route => {
                  if (route.organization) {
                      return user?.isSuperuser
                  }
                  if (route.isAuth) {
                      return !!user
                  }
                  if (route.path.includes("logout")) {
                    return false
                  }
                  return true
              })
                .map((route, index, arr) => (
                    <span key={index}>
                        <S.Link to={route.path}>{route.title}</S.Link>
                        {(index + 1) < arr.length ? ' / ' : ''}
                    </span>
                ))
            }

            <br/>
            <br/>

            <p>
              Cyber Crime Investigation, Intelligence & Digital Forensics - URLForensics is a 
              toolset developed by DIGITPOL. @2013 - {new Date().getFullYear()}
            </p>
        </Container>
    </S.Footer>
  )
}

export default Footer
